
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { VfbElement } from './Element';

@Component
export default class ElementFileExtra extends Vue {
  @Prop({ required: true })
  builderElement!: VfbElement;

  get accept(): string {
    return this.builderElement.accept ?? '';
  }

  set accept(value: string) {
    if (typeof this.builderElement.accept === 'undefined') {
      this.$set(this.builderElement, 'accept', value); // if property didn't exist, it needs to be set this way, so vue makes it reactive
    }
    this.builderElement.accept = value;
  }
}
